import { render, staticRenderFns } from "./papers.vue?vue&type=template&id=1baf7afe&scoped=true"
import script from "./papers.vue?vue&type=script&lang=js"
export * from "./papers.vue?vue&type=script&lang=js"
import style0 from "./papers.vue?vue&type=style&index=0&id=1baf7afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf7afe",
  null
  
)

export default component.exports